module.exports = __webpack_public_path__ + "img/x5.f038ec06.jpg";